import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import { setExpandedFilters, setSelectedFilters, showFilters } from "../../../../actions/actionFunctions";
import FiltersBody from "./filtersBody";

class FiltersClass extends PureComponent {

  static propTypes = {
    id: PropTypes.string.isRequired,
    searchText: PropTypes.string.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
    childItem: PropTypes.object
  };

  blurClickSet = false;

  componentDidMount() {
    this.props.setSelectedFilters([]); // reset filters on stones & color step
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.childItem && (!this.props.childItem
      || (this.props.childItem && nextProps.childItem.text !== this.props.childItem.text))) {
      this.props.setSelectedFilters([]);
      this.props.setExpandedFilters([]);
    }
    if (nextProps.visible && !this.blurClickSet) {
      this.blurClickSet = true;
      document.addEventListener('click', this.handleWrapperBlur);
    }
  }

  handleWrapperBlur = (e) => {
    if (!e.target.closest('[class*="filters"]') && !e.target.closest(".materials-button--search") && this.props.id === this.props.activeFilterId) {
      this.props.showFilters(false);
      document.removeEventListener('click', this.handleWrapperBlur);
      this.blurClickSet = false;
    }
  };

  render() {
    return (
      <div className={"filters-container" + (this.props.visible ? " filters-container--visible" : "")}>
        {this.props.visible && this.props.childItem ? (
          <FiltersBody id={this.props.id}
                       searchText={this.props.searchText}
                       handleSearchInputChange={this.props.handleSearchInputChange}
                       childItem={this.props.childItem}
          />
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    activeFilterId: store.filterState.filterId,
    visible: store.filterState.showFilters,
    filterVisible: store.filterState.filterVisible,
  };
};

const mapDispatchToProps = {
  setSelectedFilters,
  setExpandedFilters,
  showFilters,
};
export default connect(mapStateToProps, mapDispatchToProps)(FiltersClass);
